import {getData} from "../api/get-data";

export const getAuthCode = (phone, type = `sms`, resolveHandler = () => {}, rejectHanlder = () => {}) => {
  getData({
    [`get_auth_code`]: {
      [`phone`]: phone,
      [`type`]: type,
    }
  })
  .then((response) => {
    if (response.result === `OK`) {
      resolveHandler();
    }

    if (response.result === `ERROR`) {
      rejectHanlder(response.error);
    }
  })
  .catch(() => {
    rejectHanlder();
  });
};
